(function ($, Global) {
    function FiltersMobileComponent() {
        // Déclaration class objet
    }

	FiltersMobileComponent.prototype.initEvents = function () {
		this.publishers();
	}

	FiltersMobileComponent.prototype.publishers = function () {
        $(document).on('click', '.filters-mobile .filters-theme-navigation a', function () {
            $.Topic('archives-filters-change').publish(this);
        });
	}

	window.FiltersMobileComponent = FiltersMobileComponent;
}(jQuery, window));